import Button from 'style-guide/Button';
import RemoveMessageModalWrapper from './style/RemoveMessageModalWrapper';

const RemoveMessageModal = ({ hideModal, params: { onOk, onCancel, title } }) => (
  <RemoveMessageModalWrapper className='row'>
    <div className='col-12 d-flex justify-content-start pb--40'>{title}</div>
    <div className='col-12 d-flex justify-content-end'>
      <Button
        className='mr--16'
        variant='secondary'
        onClick={() => {
          hideModal();
          onCancel?.();
        }}
      >
        Cancel
      </Button>
      <Button
        className='confirmation-button'
        variant='primary'
        onClick={() => {
          hideModal();
          onOk?.();
        }}
      >
        Yes, remove
      </Button>
    </div>
  </RemoveMessageModalWrapper>
);

export default RemoveMessageModal;
